import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import downloadIcon from 'assets/images/icons/download-green-underlined.svg';
import AlertModal from 'components/common-components/AlertModal';
import { CallAPI } from 'actions/General';

const PdfVersionModal = ({ showModal, setShowModal, submissionId }) => {
  const { t } = useTranslation();
  const [pdfVersions, setPdfVersions] = useState([]);

  const getPdfHistory = async () => {
    let result = await CallAPI('GET_SUBMISSION_PDF_HISTORY', null, submissionId, null, null);
    if (result.status) {
      setPdfVersions(result.data);
    }
  };

  useEffect(() => {
    getPdfHistory();
  }, []);

  const closeModal = () => setShowModal(false);

  const handleDownload = (url) => {
    const fileUrl = url;
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = 'file.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <AlertModal
      show={showModal}
      size='sm'
      actionButtons={[]}
      showCloseButton
      closeModal={closeModal}
    >
      <div className='w-100'>
        <div className='d-flex flex-column gap-1 mb-2'>
          <label className='theme-font-inter-medium theme-text-black-1 theme-size-1_1'>
            {t('text_current_version')}
          </label>
          <span>{`${pdfVersions.length + 1}.0`}</span>
        </div>

        <div>
          <label className='w-100 pb-2 mb-2 border-bottom-grey-10-h-1 theme-font-inter-medium theme-text-black-1 theme-size-1_1'>
            {t('text_old_versions')}
          </label>
          <div className='d-flex flex-column align-items-start gap-2'>
            {pdfVersions.map((version, index) => (
              <div
                key={index}
                className='d-flex justify-content-between align-items-center gap-3 mb-1'
              >
                <span>{`${pdfVersions.length - index}.0`}</span>
                <img
                  src={downloadIcon}
                  className='cursor-pointer'
                  onClick={() => handleDownload(version.url)}
                />
              </div>
            ))}
            {pdfVersions.length === 0 && <span>{t('text_none')}</span>}
          </div>
        </div>
      </div>
    </AlertModal>
  );
};

PdfVersionModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setShowModal: PropTypes.func.isRequired,
  submissionId: PropTypes.string,
};

export default PdfVersionModal;
